import { PricingScreen } from './PricingScreen.jsx';

export default {
  path: '/pricing',
  element: <PricingScreen />,
  protected: true,
  permission: 'pricing.view',
  standalone: false,
  sidebar: { label: 'إعدادات التسعير', icon: 'pricing', group: 'admin', order: 90 }
};
